import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuthContext';
import SocijalnaLogovanja from '../components/SocijalnaLogovanja';

export default function Registracija() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [ime, setIme] = useState('');
  const [email, setEmail] = useState('');
  const [lozinka, setLozinka] = useState('');
  const [potvrda, setPotvrda] = useState('');
  const [greska, setGreska] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setGreska('');

    if (lozinka !== potvrda) {
      return setGreska('Lozinke se ne poklapaju.');
    }
    if (lozinka.length < 6) {
      return setGreska('Lozinka mora imati najmanje 6 karaktera.');
    }

    setLoading(true);
    try {
      await register(email, lozinka, ime);
      navigate('/');
    } catch (err) {
      const poruke = {
        'auth/email-already-in-use': 'Ovaj email je već registrovan.',
        'auth/invalid-email': 'Email adresa nije ispravna.',
        'auth/weak-password': 'Lozinka je presla. Koristite najmanje 6 karaktera.',
      };
      setGreska(poruke[err.code] || 'Greška pri registraciji. Pokušajte ponovo.');
    }
    setLoading(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">🫀</div>
          <h1>Registracija</h1>
          <p>Kreirajte nalog i počnite da pratite pritisak</p>
        </div>

        {greska && <div className="alert alert-error" style={{ marginBottom: 16 }}>{greska}</div>}

        {/* Social registracija */}
        <SocijalnaLogovanja onGreska={setGreska} />

        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          margin: '20px 0', color: '#9c8278', fontSize: '0.82rem'
        }}>
          <div style={{ flex: 1, height: 1, background: '#e8ddd8' }} />
          ili registrujte se emailom
          <div style={{ flex: 1, height: 1, background: '#e8ddd8' }} />
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Vaše ime</label>
            <input
              type="text"
              placeholder="Marko Marković"
              value={ime}
              onChange={e => setIme(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Email adresa</label>
            <input
              type="email"
              placeholder="vas@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label>Lozinka</label>
            <input
              type="password"
              placeholder="Minimum 6 karaktera"
              value={lozinka}
              onChange={e => setLozinka(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label>Potvrdite lozinku</label>
            <input
              type="password"
              placeholder="Ponovite lozinku"
              value={potvrda}
              onChange={e => setPotvrda(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%', padding: '14px' }}>
            {loading ? 'Kreiranje naloga...' : 'Kreiraj nalog'}
          </button>
        </form>

        <div className="auth-switch">
          Već imate nalog? <Link to="/prijava">Prijavite se</Link>
        </div>
      </div>
    </div>
  );
}
